import { render, staticRenderFns } from "./More.vue?vue&type=template&id=3629ea11&scoped=true&"
import script from "./More.vue?vue&type=script&lang=ts&"
export * from "./More.vue?vue&type=script&lang=ts&"
import style0 from "./more.scss?vue&type=style&index=0&id=3629ea11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3629ea11",
  null
  
)

export default component.exports